import { Component, Input } from '@angular/core';

@Component({
    selector: 'kh-main-header',
    templateUrl: './main-header.component.html',
    styleUrls: ['./main-header.component.scss'],
})
export class MainHeaderComponent {
    @Input() hasSubheader = false;
}
